import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";
import AuthModule from './modules/auth.js'
import LocaleModule from './modules/locale.js'

const store = createStore({
  modules: {
    auth  : AuthModule,
    locale: LocaleModule
  },
  plugins: [createPersistedState(
      {storage: window.sessionStorage}
  )],
})

export default store
